// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'calendar-now';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.344 2.808H1.656c-.648 0-1.152.504-1.152 1.152v12.384c0 .648.504 1.152 1.152 1.152h14.616c.648 0 1.152-.504 1.152-1.152V3.96c0-.648-.504-1.152-1.08-1.152zM.576 7.344h16.848M5.04 4.464V.576m7.92 3.888V.576' />
    <path fill='currentColor' d='M7.5 12.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
